import formatcoords from 'formatcoords';
import { useState } from 'react';
import { useMapEvents } from 'react-leaflet';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
  showSummary: boolean;
  path?: string;
}

const MapEventCoordinate: React.FC<Props> = ({ showSummary }) => {
  const [latLng, setLatLng] = useState<{ lat: number; lng: number }>({
    lat: 0,
    lng: 0,
  });
  const path = useLocation();
  const map = useMapEvents({
    click() {
      // map.locate();
    },
    mousemove(e) {
      setLatLng(e.latlng);
    },
  });

  return (
    <CoordWrapper id='rambona' showSummary={showSummary} path={path.pathname}>
      {formatcoords(latLng.lat, latLng.lng).format('DD MM ss X', {
        latLonSeparator: ', ',
        decimalPlaces: 0,
      })}
    </CoordWrapper>
  );
};

const CoordWrapper = styled.div<Props>`
  padding: 4px 16px;
  border-radius: 4px;
  background-color: white;
  position: absolute;
  z-index: 998;
  bottom: ${(props) =>
    props.path && ['/home', '/custom-home'].includes(props.path)
      ? '70px'
      : '10px'};
  left: ${(props) => (props.showSummary ? '390px' : '10px')};
`;

export default MapEventCoordinate;
